import { API } from "../../constAPI";

const withParams = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, value);
    }
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

const throwCreditApiError = (data, fallback) => {
  const error = new Error(data?.detail || data?.message || data?.error || fallback);
  error.code = data?.code || data?.error;
  error.status = data?.status;
  error.data = data;
  throw error;
};

export const getCreditLedger = (token, params = {}) => {
  return fetch(`${API}/api/admin/credits/ledger${withParams(params)}`, {
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
  })
    .then(async (response) => {
      const data = await response.json().catch(() => null);
      if (!response.ok) {
        throw new Error(data?.error || data?.message || "Failed to load credit ledger");
      }
      return data;
    });
};

export const manualConsumeCredit = (token, payload) => {
  return fetch(`${API}/api/admin/credits/manual-consume`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const data = await response.json().catch(() => null);
    if (!response.ok) {
      throwCreditApiError(data, "Failed to adjust credit balance");
    }
    return data;
  });
};
